// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PaymentBatchDetailTransactionModel {
    static getAttributeTypeMap() {
        return PaymentBatchDetailTransactionModel.attributeTypeMap;
    }
}
PaymentBatchDetailTransactionModel.discriminator = undefined;
PaymentBatchDetailTransactionModel.additionalProperties = false;
PaymentBatchDetailTransactionModel.attributeTypeMap = [
    {
        "name": "fundsRecoveredFromClaimGroupId",
        "baseName": "fundsRecoveredFromClaimGroupId",
        "type": "number"
    },
    {
        "name": "expectedAmount",
        "baseName": "expectedAmount",
        "type": "number"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "actualAmount",
        "baseName": "actualAmount",
        "type": "number"
    },
    {
        "name": "message",
        "baseName": "message",
        "type": "string"
    },
    {
        "name": "transactionDate",
        "baseName": "transactionDate",
        "type": "Date"
    },
];
//# sourceMappingURL=paymentBatchDetailTransactionModel.js.map